/**
 * @Description
 * 注意该文件也被分享页引用了
 */

import { FC, useState } from 'react';
import styles from './index.module.less';
import V2Container from '../../Data/V2Container';

const SkeletonMapDetail: FC<any> = () => {
  const [mainHeight, setMainHeight] = useState<number>(0);
  // const [rightItemNum, setRightItemNum] = useState<number>(0);
  // setRightItemNum(Math.ceil(mainHeight / 48));

  const renderRightItem = () => {
    const renderDiv: any = [];
    const rightItemNum = Math.ceil(mainHeight / 48);
    for (let i = 0; i < rightItemNum; i++) {
      renderDiv.push(<div className={`${styles.context} ${styles.common}`} key={i}></div>);
    }
    return renderDiv;
  };

  return (
    <V2Container
      className={styles.container}
      style={{ height: 'calc(100vh - 64px)' }}
      emitMainHeight={h => setMainHeight(h)}
      extraContent={{
        top: <>
          {/* title */}
          <div className={styles.titleBox}>
            <div className={`${styles.title} ${styles.common}`}></div>
            <div className={`${styles.btn} ${styles.common}`}></div>
          </div>

          {/* 标签 */}
          <div className={`${styles.tag} ${styles.common}`}></div>
        </>,
      }}
    >
      {/* 内容 */}
      <div className={styles.box}>
        <div className={styles.contextBox}>
          <div className={styles.left}>
            <div className={`${styles.context} ${styles.common}`} style={{ height: mainHeight }}></div>
          </div>
          <div className={styles.right}>
            {renderRightItem()}
          </div>
        </div>
      </div>
    </V2Container>
  );
};

export default SkeletonMapDetail;
